import React from 'react'
import { css } from '@linaria/core'
import PropTypes from 'prop-types'
import { boolAttr, sanitizeProps } from '@fs/zion-frontend-friends'
import { Paragraph } from '../typography'
import Separator from '../separator'
import { colors } from '../theme'

const dividerCss = css`
  border-top: 1px solid ${colors.transparent.gray10};
  position: relative;
  margin: 0 0 -1px;

  &[full-width] {
    width: calc(100% + var(--bleedable-sides) * 2);
    margin: 0 calc(var(--bleedable-sides) * -1);
  }
`

export default function Divider({ fullWidth = false, marginY = 'none', label, ...props }) {
  return (
    <div style={{ padding: `var(--spacer-${marginY}) 0` }}>
      <div className={dividerCss} full-width={boolAttr(fullWidth)} {...sanitizeProps(props)} role="separator" />
      {label && (
        <Paragraph size="xs" as="div" secondary>
          <Separator size="nano" />
          {label}
        </Paragraph>
      )}
    </div>
  )
}

Divider.propTypes = {
  /** Bleed the divider line to the sides */
  fullWidth: PropTypes.bool,

  /** Adds padding to the top and bottom of the divider. */
  marginY: PropTypes.oneOf(['xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'nano', 'none']),

  /** An optional label for the divider. NOTE: If you intend on putting a HeaderBlock below your divider, you should use the `overline` prop from HeaderBlock instead. */
  label: PropTypes.string,
}
